import { Checkbox as AntCheckbox } from 'antd';
import css from './checkbox.module.scss';

export default function Checkbox({ children, ...rest }: any) {
    const classList = [css.efCheckbox];
    const props = { ...rest };
    if (rest.className) {
        classList.push(rest.className);
        props.className = classList;
    }
    return (
        <AntCheckbox {...props}>
            <span>{children}</span>
        </AntCheckbox>
    );
}
